var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamificationCry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_5729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9554 17.0144C30.1681 17.0144 32.7726 14.408 32.7726 11.1927C32.7726 7.97749 30.1681 5.37103 26.9554 5.37103C23.7426 5.37103 21.1382 7.97749 21.1382 11.1927C21.1382 14.408 23.7426 17.0144 26.9554 17.0144Z",
    fill: "#050607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.197 9.28224C31.357 8.29544 30.6875 7.36563 29.7014 7.20544C28.7154 7.04526 27.7863 7.71537 27.6262 8.70218C27.4662 9.68898 28.1358 10.6188 29.1218 10.779C30.1078 10.9392 31.0369 10.269 31.197 9.28224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5308 12.2427C24.5308 12.8419 24.0458 13.3273 23.447 13.3273C22.8483 13.3273 22.3633 12.8419 22.3633 12.2427C22.3633 11.6434 22.8483 11.1581 23.447 11.1581C24.0458 11.1581 24.5308 11.6434 24.5308 12.2427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04912 17.0144C11.2619 17.0144 13.8663 14.408 13.8663 11.1927C13.8663 7.97749 11.2619 5.37103 8.04912 5.37103C4.83638 5.37103 2.23193 7.97749 2.23193 11.1927C2.23193 14.408 4.83638 17.0144 8.04912 17.0144Z",
    fill: "#050607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2898 9.28291C12.4498 8.2961 11.7802 7.36629 10.7942 7.20611C9.80816 7.04593 8.87906 7.71604 8.71901 8.70284C8.55895 9.68965 9.22854 10.6195 10.2146 10.7796C11.2006 10.9398 12.1297 10.2697 12.2898 9.28291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62407 12.2427C5.62407 12.8419 5.1391 13.3273 4.54031 13.3273C3.94151 13.3273 3.45654 12.8419 3.45654 12.2427C3.45654 11.6434 3.94151 11.1581 4.54031 11.1581C5.1391 11.1581 5.62407 11.6434 5.62407 12.2427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5762 24C21.0517 24 20.6187 23.5815 20.6063 23.0516C20.5939 22.7495 20.4034 20.0528 17.1744 20.0528C13.9454 20.0528 13.6682 22.7693 13.6484 23.0788C13.6163 23.6112 13.1437 24.0173 12.629 23.9926C12.097 23.9653 11.6863 23.5147 11.711 22.9823C11.711 22.9327 11.998 18.1114 17.1719 18.1114C22.3458 18.1114 22.5412 22.9575 22.5437 23.0045C22.5561 23.5394 22.133 23.9851 21.596 23.9975C21.5886 23.9975 21.5812 23.9975 21.5738 23.9975L21.5762 24Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5849 15.6228C31.5849 15.6228 29.937 17.5518 29.9617 19.1242C29.9815 20.4267 31.0133 20.813 31.8645 20.7487C32.7998 20.6793 33.74 19.9884 33.4357 18.5151C33.1734 17.2447 31.5849 15.6228 31.5849 15.6228Z",
    fill: "#5AC5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5849 15.6228C31.5849 15.6228 29.937 17.5518 29.9617 19.1242C29.9815 20.4267 31.0133 20.813 31.8645 20.7487C32.7998 20.6793 33.74 19.9884 33.4357 18.5151C33.1734 17.2447 31.5849 15.6228 31.5849 15.6228Z",
    fill: "#5AC5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1398 19.0871C31.1398 19.5427 30.9245 19.9117 30.6573 19.9117C30.3901 19.9117 30.1748 19.5427 30.1748 19.0871C30.1748 18.6314 30.3901 18.2625 30.6573 18.2625C30.9245 18.2625 31.1398 18.6314 31.1398 19.0871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.969944 4.91787C0.435485 4.91787 0 4.48452 0 3.94717C0 3.40982 0.433011 2.97647 0.96747 2.97647C1.01696 2.97647 5.99782 2.93438 9.43221 0.326864C9.8578 0.00247256 10.4665 0.0866657 10.7906 0.512584C11.1148 0.938502 11.0306 1.54766 10.6051 1.87206C6.64115 4.8832 1.20006 4.91787 0.969944 4.91787Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0325 4.78663C32.8024 4.78663 27.3588 4.75196 23.3974 1.74329C22.9693 1.4189 22.8877 0.809741 23.2118 0.383822C23.536 -0.0445721 24.1446 -0.126289 24.5702 0.198102C28.0046 2.80561 32.9855 2.84771 33.035 2.84771C33.5694 2.84771 34.0024 3.28353 34.0024 3.81841C34.0024 4.35328 33.5694 4.78663 33.0325 4.78663Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_5729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamificationCry);
export default __webpack_public_path__ + "static/media/gamification-cry.5df8d2f824759cd9b6bba9bf6c8fc14d.svg";
export { ForwardRef as ReactComponent };